@import "variables";
@import "mixins";
/*
* Text align
* ================ */
.text-middle {
	vertical-align: middle;
}

.alignleft, img.alignleft {
	text-align: left;
}

.alignright, img.alignright {
	text-align: right;
}

.aligncenter, img.aligncenter {
	text-align: center;
}